// Past-client logo wall. Placeholder slots — drop real client logos (SVG/PNG in
// /public) into LOGOS when available. No fabricated client names per brand rules.
const LOGOS = [
  // { src: "/clients/acme.svg", alt: "Acme" },
];

export default function ClientLogos() {
  const slots = LOGOS.length ? LOGOS : Array.from({ length: 5 }, (_, i) => ({ placeholder: true, key: i }));
  return (
    <section
      id="clients"
      className="relative bg-[#ffffff] border-t border-black/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-14 md:py-20">
        <div className="flex items-center justify-center gap-3 font-mono text-[12px] uppercase tracking-[0.3em] text-black/65 mb-10">
          <span className="eyebrow-bar" aria-hidden="true" />
          <span>Trusted across healthcare, legal &amp; finance</span>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-px bg-black/10 border border-black/10">
          {slots.map((item, i) => (
            <div
              key={item.key ?? i}
              className="bg-[#ffffff] h-24 md:h-28 flex items-center justify-center px-4"
            >
              {item.placeholder ? (
                <div className="h-7 w-28 rounded-sm bg-black/[0.06]" aria-hidden="true" />
              ) : (
                <img
                  src={item.src}
                  alt={item.alt}
                  className="max-h-8 max-w-[140px] w-auto object-contain opacity-70 grayscale hover:opacity-100 hover:grayscale-0 transition"
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
